import { LocalAddress } from './local-address.model';
import { LocalLocationContainer } from './local-location-container.model';
import { LocalLocationType } from './local-location-type';

export class LocalLocation {

  public id: string;
  public reference: string;
  public glid: string;
  public name: string;
  public type: LocalLocationType;
  public address: LocalAddress;
  public latitude: number;
  public longitude: number;
  public contactPhone: string;
  public contactPhoneExtension: string;
  public container: LocalLocationContainer;

  static fromDto(l): LocalLocation {
    const location = new LocalLocation();

    if (!l) {
      return null;
    }

    location.id                    = l.id;
    location.reference             = l.reference;
    location.glid                  = l.glid;
    location.name                  = l.name;
    location.type                  = l.type;
    location.address               = LocalAddress.fromDto(l.address);
    location.latitude              = l.latitude;
    location.longitude             = l.longitude;
    location.contactPhone          = l.contact_phone;
    location.contactPhoneExtension = l.contact_phone_extension;
    location.container             = LocalLocationContainer.fromDto(l.container);

    return location;
  }

}
